import { LitElement, css, html } from 'lit';

import { StateController } from '../../../helpers/state/state-management/state-controller';
import { customElement } from 'lit/decorators';
import { dispatchSettingsUpdate } from '../../../helpers/settings';
import topicData from '../../../helpers/state/topic-data';

@customElement('featured-point-color')
export class FeaturedPointColor extends LitElement {

	private readonly bindTopicState = new StateController(this, topicData);

	onChangeFeaturedPointColor(e: Event) {
		const featuredPointColor = (e.target as HTMLInputElement).value;

        dispatchSettingsUpdate(
            {
				updatedValue: featuredPointColor,
				field: 'featured_color',
                refreshMarkers: true
            },
            this
        );
	}

    onChangeClusterAccentColor(e: Event) {
        const clusterAccentColor = (e.target as HTMLInputElement).value;

        dispatchSettingsUpdate(
            {
                updatedValue: clusterAccentColor,
                field: 'cluster_accent_color',
                refreshMarkers: true
            },
            this
        );
    }

    onChangeFeaturedPointName(e: Event) {
        const featuredPointName = (e.target as HTMLInputElement).value;

        dispatchSettingsUpdate(
            {
                updatedValue: featuredPointName,
                field: 'featured_name',
                refreshMarkers: false
            },
            this
        );
    }

    render() {
        return html`
        <h4 class="helpHeader">Featured Badge Name</h4>
            <p class="helpText">
                Featured points move to the top of all lists.
                You can change the name of the badge that appears on the point.
            </p>
            <proxi-textfield
                id="featuredName"
                style="width:100%; margin-top: 0.5rem; color: grey; --mdc-text-field-outlined-idle-border-color: lightgray; --mdc-text-field-ink-color: var(--main-primary-color);"
                outlined
                value="${topicData.topic?.featured_name ?? 'Featured'}"
                @change=${this.onChangeFeaturedPointName}
            ></proxi-textfield>

            <h4 class="helpHeader">Featured Point Glow</h4>

            <color-picker
                id="featuredcolor"
                class="input"
                @change=${this.onChangeFeaturedPointColor}
                label="Featured Point Color"
                value="${topicData.topic?.featured_color ?? ''}"
                helper="This is the color of the 'featured' point halo.  You can leave this blank to use the default.">
            </color-picker>

            <h4 class="helpHeader">Cluster Accent Color</h4>

            <color-picker
                id="clusteraccentcolor"
                class="input"
                @change=${this.onChangeClusterAccentColor}
                label="Cluster Accent Color"
                value="${topicData.topic?.cluster_accent_color ?? ''}"
                helper="This is the color of the cluster accent (background and border).  You can leave this blank to use the default color, which is the map header color.">
            </color-picker>


		`;
    }

    static get styles() {
        return css`
		    .input {
                width: 100%;
                padding: auto 5px;
            }
        `;
    }
}
